import { whiteColor, blackColors } from 'assets/jss/material-dashboard-pro-react';

const payAnyBillStyle = (theme) => ({
	radioContainer: {
		display: 'flex',
		paddingTop: 10,
	},
	radio: {
		flex: 1,
	},
	contentWrapper: {
		backgroundColor: whiteColor,
		padding: 24,
		paddingBottom: 98,
		borderRadius: 8,
		minHeight: 648,
		position: 'relative',
	},
	tabWrapper: {
		width: 560,
		maxWidth: '100%',
		margin: '24px auto 52px auto',
	},
	tabContentWrapper: {
		padding: '0 23px',
		[theme.breakpoints.down('xs')]: {
			padding: 0,
		},
	},
	numberInputWrapper: {
		width: '100%',
		marginRight: 8,
	},
	searchByNumberWrapper: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		marginTop: 24,
	},
	seeBillsWrapper: {
		marginTop: 15,
	},
	footerWrapper: {
		textAlign: 'right',
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: '100%',
		padding: 24,
	},
	noBillsWrapper: {
		textAlign: 'center',
		'& > svg': {
			width: 56,
			height: 56,
			marginBottom: 6,
			marginTop: 64,
			color: blackColors[4],
		},
	},
	paymentRejectedBody: {
		marginBottom: 60,
	},
});

export default payAnyBillStyle;
